import { render, staticRenderFns } from "./OnDemand2.vue?vue&type=template&id=7c7b281b&scoped=true"
import script from "./OnDemand2.vue?vue&type=script&lang=js"
export * from "./OnDemand2.vue?vue&type=script&lang=js"
import style0 from "./OnDemand2.vue?vue&type=style&index=0&id=7c7b281b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7b281b",
  null
  
)

export default component.exports